import { render, staticRenderFns } from "./SMS.vue?vue&type=template&id=4f05631a"
import script from "./SMS.vue?vue&type=script&lang=js"
export * from "./SMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f05631a')) {
      api.createRecord('4f05631a', component.options)
    } else {
      api.reload('4f05631a', component.options)
    }
    module.hot.accept("./SMS.vue?vue&type=template&id=4f05631a", function () {
      api.rerender('4f05631a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Tenants/ChannelIcons/SMS.vue"
export default component.exports